import userHelper from 'utils/user'

function checkIsAdmin({ state, output }) {
  let user = state.get('client.user')
  if (user && userHelper(user).isAdmin()) {
    output.true()
  } else {
    output.false()
  }
}

checkIsAdmin.outputs = ['true', 'false']
export default checkIsAdmin



// WEBPACK FOOTER //
// ./src/modules/user/actions/checkIsAdmin.js